import React, { Component } from 'react'
import Section from "../../../components/Section";
import './Admission.less';
import {getProvince,getSchoolScoreList} from "../../../api/school";
import {BRANCH_LIST,BATCH_UNDERGRADUATE_LIST,BATCH_JUNIOR_LIST,NEW_BRANCH_LIST,} from "../constants/index";
import Popup from "../../../components/Popup";
class Admission extends Component {
    constructor(props){
        super(props);
        this.state={
            selectProviceId:-1,
            selectTypeCode:-1,
            provinces:[],
            newEntranceScoreList:[],
            previousScoreList:[],
            previousAllScoreList:[],
            noPreviousScoreTips:'选择文理科、批次后，查看对应录取分数',
            showExplain:false,
        }
    }
    componentDidMount(){
        getProvince().then(res => {
            this.setState({
                provinces: res.data,
            });
        });
    }
    dealScoreList=(data,type)=>{
        let newEntranceArr=[],previousArr=[];
        data.forEach(i=>{
            if(i.branch==10||i.branch==20){//branch 10=文 20=理 30=物理类 40=历史类 50=综合 null=北京新高考
                previousArr.push(i)
            }else {
                newEntranceArr.push(i)
            }
        })
        return type==='newEntrance'?newEntranceArr:previousArr;
    }
    handelGetSchoolScoreList(universityId,provinceId){
        let {selectTypeCode,}=this.state;
        let previousScoreList=[];
        getSchoolScoreList(universityId,provinceId).then(res=>{
            if(res.data.length>0){
                this.setState({
                    newEntranceScoreList:this.dealScoreList(res.data,'newEntrance'),
                    previousAllScoreList:this.dealScoreList(res.data,'previous'),
                })
                if(selectTypeCode!=-1){
                    this.dealScoreList(res.data,'previous').forEach(i=>{
                        if(i.branch==selectTypeCode){
                            previousScoreList.push(i)
                        }
                    })
                    this.setState({
                        previousScoreList,
                        noPreviousScoreTips:previousScoreList.length>0?'':'暂无相关数据，请尝试其他筛选条件'
                    })
                }
            }else {
                this.setState({
                    previousScoreList,
                    // previousAllScoreList:[],
                    newEntranceScoreList:[],
                    noPreviousScoreTips:'暂无相关数据，请尝试其他筛选条件',
                })
            }
        })
    }
    handleGoBack() {
        const { history, onBack } = this.props
        typeof onBack === 'function'
            ? onBack()
            : history.push(`/school/list`);
    }
    selectProviceChange(e){
        if(e.target.value!=-1 ){
            this.handelGetSchoolScoreList(this.props.detail.id,e.target.value);
        }else {
            this.setState({
            })
        }
        this.setState({
            selectProviceId:e.target.value,
        })
    }
    selectTypeChange(e){
        let {selectProviceId,previousAllScoreList,}=this.state;
        let previousScoreList=[];
        if(e.target.value!=-1 && selectProviceId!= -1){
            previousAllScoreList.forEach(i=>{
                if(i.branch==e.target.value){
                    previousScoreList.push(i)
                }
            })
            this.setState({
                noPreviousScoreTips:previousScoreList.length>0?'':'暂无相关数据，请尝试其他筛选条件',
            })
        }else {
            this.setState({
                noPreviousScoreTips:'选择文理科、批次后，查看对应录取分数',
            })
        }
        this.setState({
            previousScoreList,
            selectTypeCode:e.target.value,
        })
    }
    dealScoreItem(i){
        if(!i || i == 0){
            return '-'
        }else {
            return i
        }
    }
    handleExplainClick(){
        this.setState({
            showExplain:true,
        })
    }
    dealElectiveSubjects=(arr)=>{
        let result=false;
        arr.forEach(i=>{
            if(i.electiveSubjects){
                result=true
            }
        })
        return result
    }
    render() {
        let {selectProviceId, selectTypeCode, provinces ,showExplain,newEntranceScoreList,previousScoreList,previousAllScoreList,noPreviousScoreTips,}=this.state;
        let batchList = this.props.detail.type==20 ? BATCH_UNDERGRADUATE_LIST : BATCH_JUNIOR_LIST;
        let hasElectiveSubjects=this.dealElectiveSubjects(newEntranceScoreList);
        return (
            <div className='admission'>
                <Section title="近年录取分数" className='score' explain onExplainClick={this.handleExplainClick.bind(this)}>
                    <select value={selectProviceId}
                            onChange={this.selectProviceChange.bind(this)}
                            style={{color:selectProviceId==-1?'#C0C0C0':'#000'}}
                            className='select-province'
                    >
                        <option className='disable-option' value={-1} disabled >请选择省份</option>
                        {provinces.map((i,index)=>{return <option value={i.id} key={index}>{i.name}</option>})}
                    </select>
                </Section>
                {newEntranceScoreList.length>0 &&
                    <div className="table-container" style={{borderBottom:'none'}}>
                        <table>
                            <tbody>
                            <tr className='head-tr'>
                                <th>年份</th>
                                <th>类型</th>
                                <th>录取批次</th>
                                <th>招生类型</th>
                                <th>最低分/最低位次</th>
                                {hasElectiveSubjects&&<th>选考科目</th>}
                                {hasElectiveSubjects&&<th>专业组</th>}
                            </tr>
                            {newEntranceScoreList.map((i,index)=>{
                                let branch=NEW_BRANCH_LIST.filter(b=>b.code==i.branch)[0]||{};
                                let batch=batchList.filter(b=>b.code==i.batch)[0]||{};
                                return <tr key={index}>
                                    <td>{this.dealScoreItem(i.year)}</td>
                                    <td>{this.dealScoreItem(branch.name)}</td>
                                    <td>{this.dealScoreItem(batch.name)}</td>
                                    <td>{this.dealScoreItem(i.enrolledType)}</td>
                                    <td>{this.dealScoreItem(i.min)}/{this.dealScoreItem(i.minRanking)}</td>
                                    {hasElectiveSubjects&&<td>{this.dealScoreItem(i.electiveSubjects)}</td>}
                                    {hasElectiveSubjects&&<td>{this.dealScoreItem(i.specialtyGroupCode)}</td>}
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                }
                {previousAllScoreList.length>0 &&
                    <div className="table-container" >
                        <div className="previous-title">
                            <select
                                value={selectTypeCode}
                                onChange={this.selectTypeChange.bind(this)}
                                style={{color:selectTypeCode==-1?'#C0C0C0':'#000'}}
                                className='select-branch'
                            >
                                <option className='disable-option' value={-1} disabled>文理科</option>
                                {BRANCH_LIST.map((i,index)=> <option value={i.code} key={index}>{i.name}</option> )}
                            </select>
                        </div>
                        <table>
                            <tbody>
                            <tr className='head-tr'>
                                <th>年份</th>
                                <th>类型</th>
                                <th>录取批次</th>
                                <th>招生类型</th>
                                <th>最低分/最低位次</th>
                            </tr>
                            {previousScoreList.map((i,index)=>{
                                let branch=BRANCH_LIST.filter(b=>b.code==i.branch)[0]||{};
                                let batch=batchList.filter(b=>b.code==i.batch)[0]||{};
                                return <tr key={index}>
                                    <td>{this.dealScoreItem(i.year)}</td>
                                    <td>{this.dealScoreItem(branch.name)}</td>
                                    <td>{this.dealScoreItem(batch.name)}</td>
                                    <td>{this.dealScoreItem(i.enrolledType)}</td>
                                    <td>{this.dealScoreItem(i.min)}/{this.dealScoreItem(i.minRanking)}</td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                        {noPreviousScoreTips && <p className='no-select-tips'>{noPreviousScoreTips}</p> }
                    </div>
                }
                {this.props.hideBottomBtn?
                    null
                    :
                    <Section>
                        <div className="school-recommendation">
                            <button onClick={this.handleGoBack.bind(this)}>返回院校列表</button>
                        </div>
                    </Section>
                }
                <Popup confirmText="我知道了" show={showExplain} onConfirm={() => this.setState({ showExplain: false })}>
                    <div>
                        <div className="explain-tips">
                            <h3>提示</h3>
                            <p>我们的数据源自于各省考试院，由于每年政策变动和加分不同，会与一些院校的官网数据存在不一致的情况，建议以各省考试院发布数据为准。</p>
                        </div>
                    </div>
                </Popup>
            </div>
        )
    }
}

export default Admission



// WEBPACK FOOTER //
// ./src/pages/School/Detail/Admission.js